import { ProfessionalContactConnectSection } from './sections/ProfessionalContactConnectSection';
import { ProfessionalContactLocationSection } from './sections/ProfessionalContactLocationSection';

/**
 * BC-4572 — revamped professional Contact tab (/contact).
 *
 * Same editorial shell as the other revamped tabs (hero, sub-nav, the
 * About-ArchiPro closing) with the "Let's connect" intro + the map + enquiry
 * location section as the body, on the site's normal light background.
 * Rendered behind the revamp flag; the route serves overview + contact data so
 * the hero, map and form all resolve.
 */
export const ProfessionalContactPageRevamp = () => {
    return (
        <main
            id="main-content"
            data-testid="professional-contact-page-revamp"
            className="bg-ground ground-grey max-md:pb-16 md:pb-[6.25rem]"
        >
            <ProfessionalContactConnectSection />
            <ProfessionalContactLocationSection />
            {/* No spacer between: the location section carries the same bottom
                padding as the other tabs' grids, and the closing band brings
                its own 100px. Stacking a third gap here is what left this tab
                with twice the run into the closing that every other tab has. */}
        </main>
    );
};
